import { ref, computed } from 'vue'

export const createLoading = () => {
    const loadingStack = ref(0)
    const setIsLoading = (isLoading) => {
        if (isLoading) {
            ++loadingStack.value;
        } else if (loadingStack.value > 0) {
            --loadingStack.value;
        }
    }
    const getIsLoading = () => loadingStack.value > 0
    const isLoading = computed(getIsLoading)
    return {
        setIsLoading,
        isLoading
    }
}
